import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';


import UnfulfilledOrderLine from './UnfulfilledOrderLine';

import { getIncompleteOrders } from '../../redux/actions/incompleteOrders';

const PurchaseOrders = ({ payload, incompleteOrders, searchIncompleteOrders }) => {

  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedSearchStatus, setSelectedSearchStatus] = useState('AWAITING_PROCESSING');

  const [orderPage, setOrderPage] = useState(0);

  useEffect(() => {
    searchIncompleteOrders(payload, orderPage, selectedSearchStatus);
  }, []);

  const refreshOrders = () => {
    searchIncompleteOrders(payload, orderPage, selectedSearchStatus);
  }

  const setIncompleteOrdersPage = (page) => {
    setOrderPage(page);
    searchIncompleteOrders(payload, page, selectedSearchStatus);
  }

  return(
    <>
      <PageHeader stripeBackground='#39a0a0' helpLink="ecwid/store-order-search-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Unfulfilled Orders</div>
              </div>
              <div className="named-area__description">
                <p>Unfulfilled orders from your store should appear in this list.</p>
              </div>
            </div>
            <div className="named-area__body">

              <div className="a-card a-card--compact">
                <div className="a-card__paddings">
                  <div className="iconable-block__content">
                    <div className="status-block">
                      <div className="status-block__central">
                        <div className="status-block__header">
                          <span className="status-block__title">Unfulfilled Orders</span>
                          <span className="status-block__edit"></span>
                        </div>
                        <div className="status-block__content">
                        { incompleteOrders.isFetching &&
                          <LoadingSpinner
                            statusText='Loading unfulfilled orders'
                          />
                        }

                        { !incompleteOrders.isFetching && incompleteOrders.status === 'success' &&
                          <>
                            <div className="flex-container">
                              <div className="flex-1">
                                <button
                                  onClick={() => refreshOrders()}
                                  className="btn btn-default"
                                >
                                  <span className="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M3.2482 7.2852C3.986 4.8062 6.2833 3 8.9999 3c1.6791 0 3.1956.6884 4.2857 1.801l.0126.0128.1964.1864h-.4008C12.5415 5 12.0937 5.4476 12.0937 6c-.0001.5523.4476 1 .9999 1.0001l2.938.0005c.5524 0 1.0002-.4477 1.0002-1V2.742c0-.5522-.4477-1-1-1s-1 .4478-1 1v.9598l-.3307-.314C13.2511 1.915 11.2315 1 8.9999 1 5.3744 1 2.3146 3.4109 1.3313 6.7148c-.1575.5293.1439 1.0861.6732 1.2436.5293.1576 1.0862-.1438 1.2437-.6732zM16.6684 11.2852c.1576-.5293-.1438-1.0861-.6732-1.2437-.5293-.1575-1.0861.1439-1.2437.6733C14.0137 13.1939 11.7164 15 8.9999 15c-1.6791 0-3.1956-.6884-4.2858-1.8009l-.0126-.0129-.195-.1851h.4082c.5522 0 1-.4478 1-1 0-.5523-.4478-1-1.0001-1L2 11.0012c-.5523 0-1 .4477-1 1v3.087c0 .5523.4477 1 1 1s1-.4477 1-1v-.7596l.2987.2836C4.7487 16.085 6.7683 17 8.9999 17c3.6255 0 6.6853-2.4109 7.6685-5.7148z"/></svg>
                                  </span>
                                  <span className="gwt-InlineLabel">Refresh Orders</span>
                                </button>
                              </div>

                              <div className="flex-container flex-1 flex-end">
                                <button
                                  className="btn btn-default"
                                  disabled={!incompleteOrders.ordersPagination.has_previous_page}
                                  onClick={() => setIncompleteOrdersPage(orderPage - 1)}
                                >
                                  <span className="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.284 9.9992H15c.5523 0 1-.4477 1-1 0-.5522-.4477-1-1-1H5.284l2.7725-3.0035c.3746-.4059.3493-1.0385-.0565-1.4131-.4058-.3746-1.0385-.3493-1.413.0565L2.2651 8.321a1 1 0 0 0 0 1.3565l4.3217 4.6819c.3746.4058 1.0073.4311 1.4131.0565.4058-.3746.4311-1.0072.0565-1.4131L5.284 9.9992z"/></svg>
                                  </span>
                                  <span className="gwt-InlineLabel">Previous Page</span>
                                </button>

                                <button
                                  className="btn btn-default"
                                  disabled={!incompleteOrders.ordersPagination.has_theoretical_next}
                                  onClick={() => setIncompleteOrdersPage(orderPage + 1)}
                                >
                                  <span className="gwt-InlineLabel">Next Page</span>
                                  <span className="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.716 9.9992H3c-.5523 0-1-.4477-1-1 0-.5522.4477-1 1-1h9.716L9.9435 4.9958c-.3746-.4059-.3493-1.0385.0565-1.4131.4058-.3746 1.0385-.3493 1.4131.0565l4.3217 4.6819a1 1 0 0 1 0 1.3565l-4.3217 4.6819c-.3746.4058-1.0073.4311-1.4131.0565-.4058-.3746-.4311-1.0072-.0565-1.4131l2.7725-3.0036z"/></svg>
                                  </span>
                                </button>

                              </div>
                            </div>

                            <hr/>

                            { incompleteOrders.orders.map((order) =>
                                <UnfulfilledOrderLine
                                  payload={payload}
                                  order={order}
                                />
                              )
                            }
                            { incompleteOrders.orders.length === 0 && orderPage === 0 &&
                              <>
                                <h4>No Unfulfilled Orders</h4>
                                <p>
                                  You're all caught up! When you have orders in the "{ selectedSearchStatus }" state, they will appear in a list here.
                                </p>
                              </>
                            }
                            { incompleteOrders.orders.length === 0 && orderPage > 0 &&
                              <>
                                <h4>No More Orders</h4>
                                <p>
                                  Click the "Previous Page" button to see unfulfilled orders.
                                </p>
                              </>
                            }
                          </>
                        }
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  incompleteOrders: state.incompleteOrders,
});

const mapDispatchToProps = (dispatch) => ({
  searchIncompleteOrders: (payload, orderPage, selectedSearchStatus) => dispatch(getIncompleteOrders(payload, orderPage, selectedSearchStatus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrders);